<!--
 * @Description: 
 * @Author:  
 * @Date: 2024-08-01 14:27:44
 * @LastEditTime: 2024-09-10 12:00:36
 * @LastEditors:  
-->
<template>
  <div class="main-container">
    <page-header>{{content.pageTitle | dealLanguage(content.enPageTitle)}}</page-header>
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="flex-wrapper">
      <div class="flex-left">
        <Affix :offset-top="94" v-if="anchor_list.length> 0">
          <Anchor :affix="false" :bounds="100" :offset-top="110" :scroll-offset="80">
            <AnchorLink v-for="item, index in anchor_list" :key="index" :href="'#' + item.id" :title="item.title" />
          </Anchor>
        </Affix>
      </div>
      <div class="flex-right">
        <div v-html="content.content" class="content" v-if="language == 'zh'"></div>
        <div v-html="content.enContent" class="content" v-if="language == 'en'"></div>
      </div>
    </div>
    <!-- <div class="flex-wrapper" v-if="language == 'en'">
      <div class="flex-left">
        <Affix :offset-top="94" v-if="en_h1_list.length > 0">
          <Anchor :affix="false" :bounds="100" :offset-top="110" :scroll-offset="80">
            <AnchorLink v-for="item, index in en_h1_list" :key="index" :href="'#' + item.id" :title="item.title" />
          </Anchor>
        </Affix>
      </div>
      <div class="flex-right">
        <div v-html="content.enContent" class="content"></div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PageHeader from '@/components/pc/pageHeader.vue'
export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? this.content.pageTitle : this.content.enPageTitle, 
    }
  },
  data() {
    return {
      // id: this.$route.params.id,
      content: '',
      h1_list: [],
      en_h1_list: [],
      loading: true
    }
  },
  components: {
    PageHeader,
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      user_key: (state) => state.user_key,
      activityId: (state) => state.activityId,
      contentNav: (state) => state.contentNav,
      mainPageContent: (state) => state.mainPageContent,
      vbef_path: (state) => state.vbef_path,
      language: (state) => state.language,
    }),
    id() {
      return this.$route.params.id
    },
    anchor_list() {
      if(this.language == 'zh') {
        return this.h1_list
      } else if (this.language == 'en') {
        return this.en_h1_list
      }
    }
  },

  created() {
    this.getMarkdown()
  },

  mounted() {
    // this.getMarkdown()
  },
  watch: {
    id: function (val) {
      this.getMarkdown()
    },
  },
  methods: {
    getMarkdown() {
      this.loading = true
      const stripHtmlTags = (str) => {
        const dom = document.createElement('div')
        dom.innerHTML = str
        str = dom.textContent || str
        return str
        return str.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, '')
      }
      this.content = {
        ...[...this.mainPageContent, ...this.contentNav].filter(
          (item) => item.id == this.$route.params.id
        )[0],
      }
      let regex_h1 = /<h1([\s\S]*?)>([\s\S]*?)<\/h1>/g
      let match
      let newContent = this.content.content
      let newEnContent = this.content.enContent
      this.h1_list = []
      this.en_h1_list = []
      while ((match = regex_h1.exec(this.content.content)) !== null) {
        this.h1_list.push({
          title: stripHtmlTags(match[2]),
          id: 'title' + match['index'],
        })
        newContent = newContent.replace(
          match[0],
          `<h1 id="title${match['index']}" ${match[1]}>${match[2]}</h1>`
        )
      }
      this.content.content = newContent.replace(/preload="none"/g, 'preload="auto"')
      while ((match = regex_h1.exec(this.content.enContent)) !== null) {
        this.en_h1_list.push({
          title: stripHtmlTags(match[2]),
          id: 'entitle' + match['index'],
        })
        newEnContent = newEnContent.replace(
          match[0],
          `<h1 id="entitle${match['index']}" ${match[1]}>${match[2]}</h1>`
        )
      }
      this.content.enContent = newEnContent.replace(/preload="none"/g, 'preload="auto"')
      this.loading = false
      // console.log(this.content);
    }
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
.flex-right
  line-height 2
  >>> .content
    overflow hidden
    width 100%
    font-size 16px
    color #1D2129
    line-height 30px
    text-align justify
    ol
      list-style auto
      padding-left 20px
      li
        list-style auto
    ul
      list-style disc
      padding-left 20px
      li
        list-style disc
    a
      color #2d7bc5
    em
      font-style italic
    img
      margin 0 auto
      display block
      max-width 100% !important
      max-height 100% !important
    span
      max-width 100% !important
      padding 0
    p
      max-width 100% !important
      margin 0
      font-size 16px
      font-weight 500
      color #1D2129
      line-height 30px
      text-align justify
    table
      width 100%
      td
        border 1px solid #e5e5e5
    iframe
      width 100% !important
      height 200px !important
    section
      max-width 100% !important
      p
        margin inherit
        font-size inherit
        font-weight inherit
        color inherit
        line-height inherit
        text-align inherit
    video
      max-width 100% !important
      max-height 600px !important
      background #000
    .toastui-editor-ww-code-block-highlighting
      overflow auto
      max-width 100% !important
</style>